import IconBase from "./Icon";

export default IconBase;
